export default __webpack_public_path__ + "static/media/da__apple.67ba9ff9.svg";